import { isWithinInterval } from 'date-fns';

import parseDate from '../formatting/parseDateToDateObject';

type ValidationRules = {
    fromDate: Date;
    toDate: Date;
};

const DEFAULT_FROM_DATE = new Date(1950, 0, 1);
const DEFAULT_TO_DATE = new Date(2050, 0, 1);

const validateDate = (date: string, rules: ValidationRules) => {
    const dateObject: Date | null = parseDate(date);
    if (!dateObject) return dateObject;

    if (
        !isWithinInterval(dateObject, {
            start: rules.fromDate || DEFAULT_FROM_DATE,
            end: rules.toDate || DEFAULT_TO_DATE,
        })
    ) {
        return null;
    }

    return dateObject;
};

export default validateDate;
